import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';

const ButtonLink = ({ children, to, ...props }) => (
    <Button component={Link} to={to} {...props}>
        {children}
    </Button>
);

ButtonLink.propTypes = {
    children: PropTypes.node.isRequired,
    to: PropTypes.string.isRequired
};

export default ButtonLink;
